import React, { Component } from 'react';
import { CardLayout, TableLayout } from '../containers/Layout';
import { TableRow, TableCell, Button, Grid, TableHead, TableBody, TableFooter, IconButton, Box, Typography } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import { SingleFooterTemplate } from '../containers/SingleTemplate';

const formatNumbers =  new Intl.NumberFormat('fr-FR',{ maximumFractionDigits: 0 })

class SingleReturnSale extends Component {
    state = { }

    componentDidMount = () => {
        console.log("[INFO] MOUNTING RETURN SALE SINGLE ");

        // const {shop} = this.props
        // if(shop.logo.filename && !shop.src){
        //     this.props.getPhoto(shop.id, shop.logo.filename)
        // }
    }
    createProductList = () => {
        const { RETURNS, PRODUCTS, sale, shop } = this.props
        console.log('====================================');
        console.log({RETURNS});
        console.log('====================================');
        return sale.products.map( saleItem => {
            let returnProd = RETURNS[saleItem.return_product_id]
            let prod = PRODUCTS[saleItem.product_id]
            // let prod = PRODUCTS[saleItem.product_ref]
            const ssTt = parseFloat(saleItem.price) // prix vendu
            let ssTtBase = parseFloat(returnProd.sell_price * saleItem.quantity) // prix base

            let PU = returnProd.sell_price 
            let discount = Math.round(( 1 - (saleItem.price) / (returnProd.sell_price * saleItem.quantity ) ) *10000) / 100 // %
            let discountAmount = ssTt - ssTtBase

            if(ssTt > ssTtBase){
                ssTtBase = ssTt
                PU = saleItem.price / saleItem.quantity
                discount = 0
                discountAmount = 0
            }
            
            console.log("PRODUCT LIST discount", discount);
            return (
                <TableRow>
                    <TableCell className="text-left">{prod.name}</TableCell>
                    <TableCell>{saleItem.quantity}</TableCell>
                    
                    <TableCell>{formatNumbers.format(PU)}</TableCell>
                    <TableCell>{formatNumbers.format(ssTtBase)}</TableCell>
                    {/* <TableCell>{discount} %</TableCell> */}
                    <TableCell>{formatNumbers.format(discountAmount)}</TableCell>
                    {/* <TableCell>{shop.TVA || 0} %</TableCell> */}
                                    
                    <TableCell>{formatNumbers.format(ssTt)}</TableCell>
                </TableRow>
            )
        })
    }

   
    render(){
        console.log("[STATE] PRODUCT",this.props);
        const { shop, client, sale} = this.props;
        return(
            <CardLayout>
                <div >
                    <IconButton 
                        type="button" 
                        onClick={this.props.handleCloseSale}
                    > 
                        <ArrowBack />
                    </IconButton>
                </div>
                <Box p={1} style={{ textAlign: "right"}}>
                    <Button color="secondary" onClick={() => window.print()}>Imprimer</Button>
                </Box>
                <div id="section-to-print" style={{padding:"25px 15px 10px"}} >
                    <Box>
                        <Box p={1}>
                            {shop &&
                                <Box p={1}>
                                    {shop.logo &&
                                    <Box className="logo">
                                        <img src={`/stocks/photos/${shop.logo.filename}`} alt=""/>
                                    </Box>
                                    }
                                    <Box>
                                        <Typography variant="body1"><b>{shop.name}</b></Typography>
                                        {shop.tel && <Typography variant="body2">{shop.tel} </Typography> }
                                        {shop.email && <Typography variant="body2">{shop.email} </Typography> }
                                        <Typography variant="body2">{shop.address}</Typography>
                                        <Typography variant="body2">{shop.city} - {shop.country}</Typography>
                                    </Box>
                                </Box>
                            }
                        </Box>
                        <Box m={1} style={{ float: "right", width: "250px"}}>
                            {client &&
                                <Box p={1}>
                                    <Typography variant="caption">Client : </Typography>
                                    <Typography variant="body1">{client.client_firstname} {(client.client_lastname).toUpperCase()}</Typography>
                                    <address>
                                        <Typography variant="body2">{client.client_tel}</Typography>
                                        <Typography variant="body2">{client.client_address}</Typography>
                                        <Typography variant="body2">{client.client_city} - {client.client_country}</Typography>
                                    </address>
                                </Box>
                            } 
                        </Box>
                        <div style={{clear: "both"}}></div>
                        <Box>
                            <Typography variant="subtitle">Facture n° {sale.id}</Typography>
                            <Typography variant="subtitle">
                                Date :  {(new Date(sale.date)).toLocaleString('fr-FR')}
                            </Typography>
                        </Box>
                        <hr/>
                        
                        <Box style={{ minHeight: "600px"}}>
                            <TableLayout>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="text-left">Produit</TableCell>
                                        <TableCell>Quantité</TableCell>
                                        <TableCell>PU HT</TableCell>
                                        <TableCell>Total HT</TableCell>
                                        <TableCell >Remise</TableCell>
                                        {/* <TableCell>TVA</TableCell> */}
                                        {/* <TableCell>PU Vente</TableCell> */}
                                        <TableCell>Total TTC</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.createProductList()}
                                    <TableRow>
                                        <TableCell colSpan={7}></TableCell>
                                    </TableRow>
                                </TableBody>
                                
                                <TableFooter>
                                    <TableRow>
                                        <TableCell colSpan={2}></TableCell>
                                        <TableCell>TOTAL</TableCell>
                                        <TableCell className="f-700">
                                            {/* {this.getTotal()[1]} */}
                                        </TableCell>
                                        <TableCell className="f-700">
                                            - {sale.discount || 0}
                                        </TableCell>
                                        {/* <TableCell></TableCell> */}
                                        <TableCell className="f-700">
                                            {sale.total_price}
                                        </TableCell>
                                        
                                    </TableRow>
                                    
                                </TableFooter>
                            </TableLayout>     
                        </Box>
                    </Box>
                    <SingleFooterTemplate shop={shop} />
                </div>
            </CardLayout>
        )
    }
}

export default SingleReturnSale;